import { Environment, isValidEnvironment } from "@/types/Environment";

export const VUE_APP_ENV = ((): Environment => {
  const env = process.env.VUE_APP_ENV;
  if (env !== undefined && isValidEnvironment(env)) {
    return env;
  }
  throw new Error(`利用できないVUE_APP_ENV環境変数が指定されています: ${env}`);
})();
